 
import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { useEffect, useState } from 'react';
import {
  Breadcrumbs,
  CardComponent,
  DashedStandardDropdown,
  DottedText,
  MultiProgressBarsChart,
  OverviewCard,
  PageTitleAndSubTitle,
  ValueSliderComponent,
  valueWithText,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import properties from '../../core-utils/properties';
import Loader from '../../_components/molecules/Loader';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import risingRiskPageMessages from '../../core-utils/messages/risingRiskPageMessages';
import axios from 'axios';
import Table from '@HomaHealth/ui-component-library/lib/_components/molecules/Table';
import {
  formatDiseasePrevalence,
  formatPharmacyUsage,
  TitleValueType,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { formatProcedureData } from '../../core-utils/helper-utils/risingRiskPageHelper';
import { RisingRiskSummaryCardsProps } from '../../_components/molecules/RisingRiskOverviewTab';
import { getTruncatedText } from '../MemberSummaryPage';
import { MonthMap } from '../../core-utils/helper-utils/EditDuration';
import moment from 'moment';
import {
  DATE_FORMAT,
  MONTH_YEAR_FORMAT,
} from '../../core-utils/messages/CommonConstants';
import { useStores } from '../../stores';
import { PATIENT_DETAILS, RISING_RISK } from '../../core-utils/routes';
import { useNavigate } from 'react-router-dom';
import { MembersOfSelectedDiseaseDataProps } from '../RisingRiskPage';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { CircularLoader } from '@HomaHealth/ui-component-library';

const RisingRiskDetailsPage = () => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
    membersHeadingGrid: {
      margin: '10px 0px 30px 0px',
    },
    membersTableHeader: {
      height: '48px',
      backgroundColor: '#F2F4FA',
    },
    mainGrid: {
      marginLeft: '63px',
    },
    topGrid: {
      marginTop: '38px',
    },
    belowCards: {
      marginRight: '24px',
      marginBottom: '24px',
    },
    belowSummaryCards: {
      display: 'flex',
      marginTop: '20px',
    },
    valueSliderComponentValueStyles: {
      marginTop: '26px',
    },
  });

  const { classes } = useStyles();
  const navigate = useNavigate();

  const messages = risingRiskPageMessages.RISING_RISK_PAGE;
  const [loading, setLoading] = useState<boolean>(false);
  const memberSummaryStore = useStores().memberSummaryStore;

  const risingRiskStore = useStores().risingRiskStore;
  const [selectedDiseaseName, setSelectedDiseaseName] = useState(
    risingRiskStore.selectedDiseaseName,
  );
  const listOfDiseases = risingRiskStore.listOfDiseases;
  const memberUniqueIdList = risingRiskStore.membersUniqueList;

  const [topConditionsByMember, setTopConditionsByMember] = useState<
    TitleValueType[]
  >([]);
  const [topConditionsByCost, settopConditionsByCost] = useState<
    TitleValueType[]
  >([]);
  const [
    topConditionsDropdownValue,
    setTopConditionsDropdownValue,
  ] = useState<string>('Member');

  const [topMedicationsByMember, setTopMedicationsByMember] = useState<
    TitleValueType[]
  >([]);
  const [topMedicationsByCost, settopMedicationsByCost] = useState<
    TitleValueType[]
  >([]);
  const [
    topMedicationsDropdownValue,
    setTopMedicationsDropdownValue,
  ] = useState<string>('Member');

  const [topProceduresByMember, setTopProceduresByMember] = useState<
    TitleValueType[]
  >([]);
  const [topProceduresByCost, settopProceduresByCost] = useState<
    TitleValueType[]
  >([]);
  const [
    topProceduresDropdownValue,
    setTopProceduresDropdownValue,
  ] = useState<string>('Member');

  const [topConditionsLoading, setTopConditionsLoading] = useState<boolean>(
    false,
  );
  const [topMedicationsLoading, setTopMedicationsLoading] = useState<boolean>(
    false,
  );
  const [topProceduresLoading, setTopProceduresLoading] = useState<boolean>(
    false,
  );

  const [riskProbability, setRiskProbability] = useState(0.7);

  const [isDataEmpty, setIsDataEmpty] = useState(true);

  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const [
    risingRiskSummaryCards,
    setRisingRiskSummaryCards,
  ] = useState<RisingRiskSummaryCardsProps>({
    avgRiskScore: '',
    latentRisk: '',
    chronicDiagnosed: '',
    acuteDiagnosed: '',
  });

  const [
    membersOfSelectedDiseaseData,
    setMembersOfSelectedDiseaseData,
  ] = useState<MembersOfSelectedDiseaseDataProps[]>([]);

  const [
    membersOfSelectedDiseaseLoading,
    setMembersOfSelectedDiseaseLoading,
  ] = useState<boolean>(false);

  const handleOnMemberClick = (id: string) => {
    if (id !== null) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          messages.TITLE,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => navigate(RISING_RISK),
        ],
        [
          'text',
          selectedDiseaseName,
          {
            color: '',
          },
        ],
      ]);
      navigate(PATIENT_DETAILS);
    }
  };

  const membersOfSelectedDiseaseColumns = [
    {
      Header: 'Member ID',
      Footer: 'MEMBER ID',
      accessor: 'member_unique_id',
      sticky: 'left',
      Cell: ({ value }: any) => (
        <>
          <div
            onClick={() => handleOnMemberClick(value)}
            style={{ fontWeight: 500, cursor: 'pointer' }}
          >
            <DottedText text={value} />
          </div>
        </>
      ),
    },
    {
      Header: 'Risk Score',
      Footer: 'RISK SCORE',
      accessor: 'risk_score',
      sticky: 'left',
      cellType: 'none',
      icon: 'none',
      // Cell: ({ value }: any) => <>{Math.round(value)}</>,
    },
    {
      Header: 'Risk Contributing Conditions',
      Footer: 'RISK CONTRIBUTING CONDITIONS',
      accessor: 'relevant_conditions',
      Cell: ({ value }: any) => {
        // Remove the single quotes
        const valuesWithoutQuotes = value.replace(/'/g, '');

        // Split the string into an array of values
        const valuesArray = valuesWithoutQuotes.split(', ');

        // Join the array elements with the pipe character as the separator
        const formattedValues = valuesArray.join(' | ');

        return <>{getTruncatedText(formattedValues, '700px')}</>;
      },
    },
  ];

  const employerGroupStore = useStores().employerGroupStore;
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [areDatesReady, setAreDatesReady] = useState<boolean>(false);
  const [startMonthYearString, setStartMonthYearString] = useState<string>('');
  const [endMonthYearString, setEndMonthYearString] = useState<string>('');
  const [planStartMonth, setPlanStartMonth] = useState<string>('');
  const [yearArray, setYearArray] = useState<string[]>([]);

  const [pageIndexForMembers, setPageIndexForMembers] = useState(0);
  const [totalItemsForDisease, setTotalItemsForDisease] = useState(0);
  const [totalPagesForDisease, setTotalPagesForDisease] = useState(0);
  const [disablePreviousButton, setDisablePreviousButton] = useState(false);
  const [disableNextButton, setDisableNextButton] = useState(false);

  const [pageNumberForTopConditions, setPageNumberForTopConditions] = useState(
    1,
  );
  const [
    pageNumberForTopMedications,
    setPageNumberForTopMedications,
  ] = useState(1);
  const [pageNumberForTopProcedures, setPageNumberForTopProcedures] = useState(
    1,
  );
  const [
    totalPagesForTopConditions,
    setTotalPagesForTopConditions,
  ] = useState<number>(0);
  const [
    totalPagesForTopMedications,
    setTotalPagesForTopMedications,
  ] = useState<number>(0);
  const [
    totalPagesForTopProcedures,
    setTotalPagesForTopProcedures,
  ] = useState<number>(0);

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handlePageChangeForTopConditions = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumberForTopConditions(value);
  };

  const handlePageChangeForTopMedications = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumberForTopMedications(value);
  };

  const handlePageChangeForTopProcedures = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumberForTopProcedures(value);
  };

  const handlePreviousPage = () => {
    if (pageIndexForMembers <= 0) {
      setDisablePreviousButton(true);
    } else {
      setDisablePreviousButton(false);
      setPageIndexForMembers(pageIndexForMembers - 1);
    }
  };

  const handleNextPage = () => {
    if (pageIndexForMembers >= totalPagesForDisease - 1) {
      setDisableNextButton(true);
    } else {
      setDisableNextButton(false);
      setPageIndexForMembers(pageIndexForMembers + 1);
    }
  };

  const getDates = async () => {
    setLoading(true);
    const dateFilterResponse = employerGroupStore.employerGroupResponseData;
    const monthNumber = MonthMap.get(dateFilterResponse.end_month)?.monthNumber;
    const defaultDate = new Date(
      monthNumber + '-01-' + dateFilterResponse.end_year,
    );

    setStartDate(
      moment(defaultDate).subtract(11, 'months').format(DATE_FORMAT),
    );

    setStartMonthYearString(
      moment(defaultDate).subtract(11, 'months').format(MONTH_YEAR_FORMAT),
    );

    setEndDate(moment(defaultDate).endOf('month').format(DATE_FORMAT));

    setEndMonthYearString(
      moment(defaultDate).endOf('month').format(MONTH_YEAR_FORMAT),
    );

    setPlanStartMonth(dateFilterResponse?.plan_start_month);

    let startYearNumber = Number(dateFilterResponse?.start_year);
    const endYearNumber = Number(
      moment(defaultDate).subtract(11, 'months').format('YYYY'),
    );

    while (startYearNumber <= endYearNumber) {
      yearArray.push(startYearNumber.toString());
      startYearNumber++;
    }
    setYearArray([...yearArray]);

    setAreDatesReady((prev: any) => !prev);

    setLoading(false);
  };

  const getDiagnosedCount = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.latentRisk +
          properties.diagnosedCount,
        {
          riskProbability: riskProbability,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          diseaseName: selectedDiseaseName,
        },
      )
      .then((response) => {
        const data = response?.data?.data;
        const tempRisingRiskSummaryCards: RisingRiskSummaryCardsProps = {
          avgRiskScore: '',
          latentRisk: '',
          chronicDiagnosed: '',
          acuteDiagnosed: '',
        };
        tempRisingRiskSummaryCards.latentRisk = data['latentRiskMembersCount'];
        tempRisingRiskSummaryCards.chronicDiagnosed =
          data['chronicDiagnosedCount'];
        setRisingRiskSummaryCards(tempRisingRiskSummaryCards);
      })
      .catch((ex) => {
        return ex;
      });
  };

  const getTopConditionsData = async (
    apiCall: any,
    setConditionsData: any,
    condtiionType: any,
  ) => {
    setTopConditionsLoading(true);
    await axios
      .post(properties.aiqBaseUrl + properties.memberSummaryBaseUrl + apiCall, {
        startDate: startDate,
        endDate: endDate,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: memberUniqueIdList,
        pageNumber: pageNumberForTopConditions - 1,
        claim_id_list: [],
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      })
      .then((res) => {
        if (res?.status === 200) {
          setConditionsData(
            formatDiseasePrevalence(
              res?.data?.data?.topDiagnosis,
              condtiionType,
              5,
            ),
          );
          setTotalPagesForTopConditions(
            Math.ceil(res?.data?.data?.totalCount / 5),
          );
        }
        setTopConditionsLoading(false);
      })
      .catch((ex) => {
        setTopConditionsLoading(false);
        return ex;
      });
  };

  const getTopMedicationsData = async (
    apiCall: any,
    setMedicationsData: any,
    medicationType: any,
  ) => {
    setTopMedicationsLoading(true);
    await axios
      .post(properties.aiqBaseUrl + properties.summaryBaseUrl + apiCall, {
        startDate: startDate,
        endDate: endDate,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: memberUniqueIdList,
        pageNumber: pageNumberForTopMedications - 1,
        claim_id_list: [],
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      })
      .then((res) => {
        if (res?.status === 200) {
          setMedicationsData(
            formatPharmacyUsage(
              res?.data?.data?.topMedications,
              medicationType,
            ),
          );
          setTotalPagesForTopMedications(
            Math.ceil(res?.data?.data?.totalCount / 5),
          );
        }
        setTopMedicationsLoading(false);
      })
      .catch((ex) => {
        setTopMedicationsLoading(false);
        return ex;
      });
  };

  const getTopProceduresData = async (apiCall: any, setProceduresData: any) => {
    setTopProceduresLoading(true);
    await axios
      .post(properties.aiqBaseUrl + properties.memberSummaryBaseUrl + apiCall, {
        startDate: startDate,
        endDate: endDate,
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        member_unique_id_list: memberUniqueIdList,
        pageNumber: pageNumberForTopProcedures - 1,
        claim_id_list: [],
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
      })
      .then((res) => {
        if (res?.status === 200) {
          setProceduresData(formatProcedureData(res?.data?.data?.procedures));
          setTotalPagesForTopProcedures(
            Math.ceil(res?.data?.data?.totalCount / 5),
          );
        }
        setTopProceduresLoading(false);
      })
      .catch((ex) => {
        setTopProceduresLoading(false);
        return ex;
      });
  };

  const getMembersOfSelectedDisease = async () => {
    setMembersOfSelectedDiseaseLoading(true);
    await axios
      .post(
        properties.aiqBaseUrl + properties.latentRisk + properties.members,
        {
          riskProbability: riskProbability,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          diseaseName: selectedDiseaseName,
          pageNumber: pageIndexForMembers,
        },
      )
      .then((response) => {
        const tempMembersData: MembersOfSelectedDiseaseDataProps[] = [];
        const tempMemberUniqueIdList: any[] = [];
        response?.data?.data?.memberDetailsList?.map((item: any) => {
          const tempData: MembersOfSelectedDiseaseDataProps = {
            member_unique_id: '',
            risk_score: '',
            relevant_conditions: '',
          };
          tempData.member_unique_id = item.member_unique_id;
          tempMemberUniqueIdList.push(tempData.member_unique_id);
          tempData.risk_score = item.risk_score;
          tempData.relevant_conditions = item.relevant_conditions;
          tempMembersData.push(tempData);
        });
        if (tempMembersData.length === 0) {
          setIsDataEmpty(true);
        } else {
          setIsDataEmpty(false);
        }

        const totalItems = response?.data?.data?.totalCount;
        setTotalItemsForDisease(totalItems);
        const totalPages = Math.floor(totalItems / 5);
        if (totalPages * 5 < totalItems) {
          setTotalPagesForDisease(totalPages + 1);
        } else {
          setTotalPagesForDisease(totalPages);
        }
        setMembersOfSelectedDiseaseData(tempMembersData);
        setMembersOfSelectedDiseaseLoading(false);
      })
      .catch((ex) => {
        setMembersOfSelectedDiseaseLoading(false);
        return ex;
      });
  };

  const recommendedTabStore = useStores().recommendedTabStore;

  const getAllCharts = async () => {
    setLoading(true);
    Boolean(startDate !== '' && endDate !== '')
      ? await Promise.all([getDiagnosedCount()])
      : getDates();
    setLoading(false);
  };

  useEffect(() => {
    getAllCharts();
  }, [selectedDiseaseName, riskProbability, areDatesReady]);

  useEffect(() => {
    Boolean(startDate !== '' && endDate !== '')
      ? getMembersOfSelectedDisease()
      : '';
  }, [pageIndexForMembers, areDatesReady]);

  useEffect(() => {
    setPageIndexForMembers(0);
  }, [riskProbability]);

  useEffect(() => {
    if (Boolean(startDate !== '' && endDate !== '')) {
      if (topConditionsDropdownValue === 'Cost') {
        getTopConditionsData(
          properties.topConditionsByCost,
          settopConditionsByCost,
          'cost',
        );
      } else {
        getTopConditionsData(
          properties.topConditionsByMember,
          setTopConditionsByMember,
          'member',
        );
      }
    }
  }, [pageNumberForTopConditions, topConditionsDropdownValue, areDatesReady]);

  useEffect(() => {
    if (Boolean(startDate !== '' && endDate !== '')) {
      if (topMedicationsDropdownValue === 'Cost') {
        getTopMedicationsData(
          properties.pharmacyUsageByCost,
          settopMedicationsByCost,
          'cost',
        );
      } else {
        getTopMedicationsData(
          properties.pharmacyUsageByMember,
          setTopMedicationsByMember,
          'member',
        );
      }
    }
  }, [pageNumberForTopMedications, topMedicationsDropdownValue, areDatesReady]);

  useEffect(() => {
    if (Boolean(startDate !== '' && endDate !== '')) {
      if (topProceduresDropdownValue === 'Cost') {
        getTopProceduresData(
          properties.topProceduresByCost,
          settopProceduresByCost,
        );
      } else {
        getTopProceduresData(
          properties.topProceduresByMember,
          setTopProceduresByMember,
        );
      }
    }
  }, [pageNumberForTopProcedures, topProceduresDropdownValue, areDatesReady]);

  const [loader] = useState<any>(<Loader />);

  return (
    <>
      {loading ? (
        loader
      ) : (
        <Grid className={classes.mainGrid}>
          <Grid container direction="row" className={classes.topGrid}>
            <Breadcrumbs
              itemList={[
                [
                  'text',
                  messages.TITLE,
                  {
                    color: patientAccessTheme.palette.primary[500],
                    fontWeight: 500,
                  },
                  () => navigate(RISING_RISK),
                ],
                [
                  'text',
                  selectedDiseaseName,
                  {
                    color: patientAccessTheme.palette.text.highemphasis,
                    fontWeight: 600,
                  },
                ],
              ]}
            />
          </Grid>

          <Grid style={{ marginTop: '20px', marginBottom: '10px' }}>
            <PageTitleAndSubTitle
              title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <DashedStandardDropdown
                    height="24px"
                    value={selectedDiseaseName}
                    options={listOfDiseases}
                    displayValue={listOfDiseases}
                    handleChange={(event: any) => {
                      const value: string = event.target.value as string;
                      setSelectedDiseaseName(value);
                      risingRiskStore.setSelectedDiseaseName(value);
                    }}
                  />
                  {/* <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: '24px',
                    }}
                  >
                    <EditDuration
                      setStartDate={setStartDate}
                      setEndDate={setEndDate}
                      getAllApis={getAllCharts}
                      isYearGrid={true}
                      startDate={moment(startDate, DATE_FORMAT)}
                      endDate={moment(endDate, DATE_FORMAT)}
                      startMonthYearString={startMonthYearString}
                      setStartMonthYearString={setStartMonthYearString}
                      endMonthYearString={endMonthYearString}
                      setEndMonthYearString={setEndMonthYearString}
                      planStartMonth={planStartMonth}
                      startYearArray={yearArray}
                    />
                  </div> */}
                </div>
              }
              subTitle={messages.DISEASES_DESCRIPTION_SUBTITLE}
              showDownloadButton={false}
              downloadButtonAction={() =>
                downloadPdf('RisingRiskReport', {
                  startDate: startDate,
                  endDate: endDate,
                  eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
                  employer:
                    employerGroupStore?.employerGroupResponseData
                      ?.employer_group_name,
                  maxClaimDate:
                    employerGroupStore?.employerGroupResponseData
                      ?.max_claim_date,
                })
              }
            />
            <TabSelection
              selectedTabIndex={selectedTabIndex}
              setSelectedTabIndex={handleSelectedIndex}
              recommendationFetched={recommendationFetched}
            />
          </Grid>
          {selectedTabIndex === 0 && (
            <>
              <Grid
                style={{
                  display: 'flex',
                  marginTop: '19px',
                  marginBottom: '32px',
                }}
              >
                {/*  Needed it Avg Risk Score is not yet finalised.
    <Grid style={{ marginRight: '24px' }}>
      <OverviewCard
        title={messages.SUMMARY_CARDS.AVG_RISK}
        value={'$' + risingRiskSummaryCards.avgRiskScore}
        rootStyles={{
          width: '176px',
        }}
      />
    </Grid> */}
                <Grid style={{ marginRight: '24px' }}>
                  <ValueSliderComponent
                    title="Risk Probability"
                    value={riskProbability}
                    minValue={0.7}
                    maxValue={1}
                    stepValue={0.1}
                    defaultValue={0.8}
                    setValue={setRiskProbability}
                  />
                </Grid>
                <Grid style={{ marginRight: '24px' }}>
                  <OverviewCard
                    title={messages.DISEASES_SUMMARY_CARDS.LATENT_RISK}
                    value={valueWithText(
                      risingRiskSummaryCards.latentRisk,
                      'Members',
                    )}
                    rootStyles={{
                      width: '276px',
                    }}
                  />
                </Grid>
                <Grid style={{ marginRight: '24px' }}>
                  <OverviewCard
                    title={messages.SUMMARY_CARDS.CHRONIC_DIAGNOSED}
                    value={valueWithText(
                      risingRiskSummaryCards.chronicDiagnosed,
                      'Members',
                    )}
                    rootStyles={{
                      width: '220px',
                    }}
                  />
                </Grid>
                {/*Needed it ACUTE DIAGNOSED Not Finalised
<Grid style={{ marginRight: '24px' }}>
  <OverviewCard
    title={messages.SUMMARY_CARDS.ACUTE_DIAGNOSED}
    value={valueWithText(
      risingRiskSummaryCards.acuteDiagnosed,
      'Members',
    )}
    rootStyles={{
      width: '176px',
    }}
  />
</Grid> */}
              </Grid>
              <Grid>
                <CardComponent
                  title={
                    <Typography
                      fontSize="14px"
                      fontFamily="Inter"
                      lineHeight="21px"
                      textColor={'#2E2F33'}
                    >
                      Member Details / <b>{selectedDiseaseName}</b>
                    </Typography>
                  }
                  subTitle="To see more about the member details click on a member"
                  width="1176px"
                  height="500px"
                  body={
                    membersOfSelectedDiseaseLoading ? (
                      <Box
                        style={{
                          display: 'flex',
                          height: '350px',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <CircularLoader />
                      </Box>
                    ) : (
                      <Table
                        tableHeight="350px"
                        onHoverRowData={() => {}}
                        classNameForTableHeaderRowTop={
                          classes.membersHeadingGrid
                        }
                        columns={membersOfSelectedDiseaseColumns}
                        data={membersOfSelectedDiseaseData}
                        isDataEmpty={isDataEmpty}
                        isCensusPreviewDataEmpty={isDataEmpty}
                        isManualPagination={true}
                        widthOfTable="1175px"
                        showPagination={true}
                        handlePreviousPage={handlePreviousPage}
                        handleNextPage={handleNextPage}
                        controlledPageIndex={pageIndexForMembers}
                        pageSize={5}
                        totalItems={totalItemsForDisease}
                        setPageIndex={setPageIndexForMembers}
                        paginationType={'numbered'}
                        disablePreviousButton={disablePreviousButton}
                        disableNextButton={disableNextButton}
                      />
                    )
                  }
                />
                <Grid className={classes.belowSummaryCards}>
                  <Grid className={classes.belowCards}>
                    <MultiProgressBarsChart
                      title={messages.TOP_CONDITIONS.TITLE}
                      subTitle={messages.TOP_CONDITIONS.SUB_TITLE}
                      dataArray={
                        topConditionsDropdownValue === 'Cost'
                          ? topConditionsByCost
                          : topConditionsByMember
                      }
                      valueSuffix="%"
                      dropdownElement={
                        <DashedStandardDropdown
                          height="24px"
                          value={topConditionsDropdownValue}
                          options={messages.TOP_CONDITIONS.DROPDOWN_OPTIONS}
                          displayValue={
                            messages.TOP_CONDITIONS.DROPDOWN_OPTIONS
                          }
                          handleChange={(event: any) => {
                            const value: string = event.target.value as string;
                            setTopConditionsDropdownValue(value);
                            setPageNumberForTopConditions(1);
                          }}
                        />
                      }
                      height="400px"
                      showPagination={true}
                      pageIndex={pageNumberForTopConditions}
                      totalPages={totalPagesForTopConditions}
                      handlePageChange={handlePageChangeForTopConditions}
                      truncatedWidth={'280px'}
                      isLoading={topConditionsLoading}
                    />
                  </Grid>
                  <Grid className={classes.belowCards}>
                    <MultiProgressBarsChart
                      title={messages.TOP_MEDICATIONS.TITLE}
                      subTitle={messages.TOP_MEDICATIONS.SUB_TITLE}
                      dataArray={
                        topMedicationsDropdownValue === 'Cost'
                          ? topMedicationsByCost
                          : topMedicationsByMember
                      }
                      valueSuffix="%"
                      dropdownElement={
                        <DashedStandardDropdown
                          height="24px"
                          value={topMedicationsDropdownValue}
                          options={messages.TOP_MEDICATIONS.DROPDOWN_OPTIONS}
                          displayValue={
                            messages.TOP_MEDICATIONS.DROPDOWN_OPTIONS
                          }
                          handleChange={(event: any) => {
                            const value: string = event.target.value as string;
                            setTopMedicationsDropdownValue(value);
                            setPageNumberForTopMedications(1);
                          }}
                        />
                      }
                      height="400px"
                      showPagination={true}
                      pageIndex={pageNumberForTopMedications}
                      totalPages={totalPagesForTopMedications}
                      handlePageChange={handlePageChangeForTopMedications}
                      truncatedWidth={'280px'}
                      isLoading={topMedicationsLoading}
                    />
                  </Grid>
                  <Grid className={classes.belowCards}>
                    <MultiProgressBarsChart
                      title={messages.TOP_PROCEDURES.TITLE}
                      subTitle={messages.TOP_PROCEDURES.SUB_TITLE}
                      dataArray={
                        topProceduresDropdownValue === 'Cost'
                          ? topProceduresByCost
                          : topProceduresByMember
                      }
                      valueSuffix="%"
                      dropdownElement={
                        <DashedStandardDropdown
                          height="24px"
                          value={topProceduresDropdownValue}
                          options={messages.TOP_PROCEDURES.DROPDOWN_OPTIONS}
                          displayValue={
                            messages.TOP_PROCEDURES.DROPDOWN_OPTIONS
                          }
                          handleChange={(event: any) => {
                            const value: string = event.target.value as string;
                            setTopProceduresDropdownValue(value);
                            setPageNumberForTopProcedures(1);
                          }}
                        />
                      }
                      height="400px"
                      showPagination={true}
                      pageIndex={pageNumberForTopProcedures}
                      totalPages={totalPagesForTopProcedures}
                      handlePageChange={handlePageChangeForTopProcedures}
                      truncatedWidth={'280px'}
                      isLoading={topProceduresLoading}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          {selectedTabIndex === 1 && (
            <RecommendationsTab
              recommendationLoading={recommendationLoading}
              isInternalPage={true}
            />
          )}
        </Grid>
      )}
    </>
  );
};
export default RisingRiskDetailsPage;
